import api from './api';

class AuthService {
  async login(credentials) {
    try {
      console.log('Attempting login with:', credentials);
      const response = await api.post('/auth/admin-login', credentials);
      console.log('Login response:', response.data);

      // Store token and role in localStorage
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_role', response.data.admin ? 'Admin' : 'User');

      return response.data;
    } catch (error) {
      console.error('Login error details:', error.response?.data);
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  }

  async logout() {
    try {
      // Since there's no logout endpoint in your backend, we'll just clear local storage
      // You can add a logout endpoint later if needed
      console.log('Logout successful - clearing local storage');
    } catch (error) {
      console.error('Logout error:', error);
    }
  }

  async getCurrentUser() {
    try {
      const token = localStorage.getItem('admin_token');
      // Decode token to check role (or store role in localStorage after login)
      const role = localStorage.getItem('admin_role');
      const endpoint = role === 'Admin' ? '/admin/profile' : '/auth/profile';
      const response = await api.get(endpoint);
      return response.data;
    } catch (error) {
      throw new Error('Failed to get user profile');
    }
  }

  async refreshToken() {
    try {
      // Since there's no refresh token endpoint in your backend, we'll skip this for now
      // You can implement token refresh later if needed
      throw new Error('Token refresh not implemented');
    } catch (error) {
      throw new Error('Token refresh failed');
    }
  }

  async changePassword(passwords) {
    try {
      // Since there's no change password endpoint in your backend, we'll skip this for now
      // You can implement password change later if needed
      throw new Error('Password change not implemented');
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Password change failed');
    }
  }
}

class AdminService {
  async getApplications() {
    return (await api.get('/admin/applications')).data;
  }
}

export const authService = new AuthService();
export const adminService = new AdminService();
